// src/api/api.js
import axios from 'axios';
import Helpers from '@utils/Helpers'

const token = Helpers.getAccessToken();

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_DJANGO_ALPHA_ENDPOINT,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    },
});

// Interceptor for request
apiClient.interceptors.request.use(
    (config) => config,
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor for response
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {

        const originalRequest = error.config;
        if (error.message == "timeout of 20000ms exceeded") {
            return
        }
        // Check if token is expired and hasn't tried to refresh token
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Call Refresh Token Api
                const refreshToken = Helpers.getRefreshToken();
                const refreshResponse = await axios.get(`${process.env.REACT_APP_DJANGO_ALPHA_ENDPOINT}/token/refresh/${refreshToken}/`);

                if (refreshResponse.status === 200) {
                    // Store New Access Token
                    const newAccessToken = refreshResponse.data.access_token;
                    Helpers.storeAccessToken(newAccessToken);

                    // Update Authorization header
                    originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    apiClient.defaults.headers["Authorization"] = `Bearer ${newAccessToken}`;

                    return apiClient(originalRequest);
                }
            } catch (refreshError) {
                Helpers.clearToken();
                Helpers.removeUserInfo();
                Helpers.redirect('/auth/login')
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
